// services/dashboardService.js - COMPLETE UPDATED VERSION
import { url } from '../constants/url';

// ==================== SHARED PAYMENT CALCULATION LOGIC ====================
// This is the SAME logic as in QuotationsScreen.jsx
// const calculateQuotationStats = (quotations) => {
//   const stats = {
//     shared: 0,
//     approved: 0,
//     rejected: 0,
//     revised: 0,
//     total: quotations.length,
//     totalQuotationAmount: 0,
//     totalApprovedAmount: 0,
//     totalReceivedAmount: 0,
//     totalPendingAmount: 0,
//     totalOverdueAmount: 0,
//     totalTokenAmount: 0,
//     totalPartiallyPaidAmount: 0,
//     totalFullyPaidAmount: 0
//   };

//   quotations.forEach(quotation => {
//     // Count by status - SAME LOGIC AS QUOTATION SCREEN
//     if (quotation.status === "quotation_shared" || quotation.status === "sent") stats.shared++;
//     if (quotation.status === "quotation_approved" || quotation.status === "approved") stats.approved++;
//     if (quotation.status === "quotation_rejected" || quotation.status === "rejected") stats.rejected++;
//     if (quotation.isRevised) stats.revised++;

//     // Calculate amounts properly - SAME LOGIC
//     const quotationAmount = Number(quotation.finalAmount) || Number(quotation.totalAmount) || 0;

//     // Calculate received amount from actual payments
//     let receivedAmount = 0;
//     let tokenAmount = 0;
//     let partiallyPaidAmount = 0;
//     let fullyPaidAmount = 0;

//     if (quotation.payments && Array.isArray(quotation.payments)) {
//       quotation.payments.forEach(payment => {
//         if (payment.paymentType === 'token' && !payment.isOverdueRecord) {
//           tokenAmount += Number(payment.amount) || 0;
//         } else if (payment.paymentType === 'partially_paid' && !payment.isOverdueRecord) {
//           partiallyPaidAmount += Number(payment.amount) || 0;
//         } else if (payment.paymentType === 'fully_paid' && !payment.isOverdueRecord) {
//           fullyPaidAmount += Number(payment.amount) || 0;
//         }
//       });

//       // SUM ALL VALID PAYMENTS (exclude overdue records)
//       receivedAmount = quotation.payments
//         .filter(payment => !payment.isOverdueRecord)
//         .reduce((sum, payment) => sum + (Number(payment.amount) || 0), 0);
//     } else {
//       // Fallback to paidAmount field if payments array doesn't exist
//       receivedAmount = Number(quotation.paidAmount) || 0;
//     }

//     const approvedAmount = (quotation.status === "quotation_approved" || quotation.status === "approved") ? quotationAmount : 0;

//     // 🚨 FIXED: Pending amount calculation - Only for approved quotations
//     let pendingAmount = 0;
//     if (quotation.status === "quotation_approved" || quotation.status === "approved") {
//       pendingAmount = Math.max(0, quotationAmount - receivedAmount);
//     }

//     stats.totalQuotationAmount += quotationAmount;
//     stats.totalApprovedAmount += approvedAmount;
//     stats.totalReceivedAmount += receivedAmount;
//     stats.totalPendingAmount += pendingAmount;
//     stats.totalTokenAmount += tokenAmount;
//     stats.totalPartiallyPaidAmount += partiallyPaidAmount;
//     stats.totalFullyPaidAmount += fullyPaidAmount;

//     // Check for overdue - use payment status AND date validation
//     if (quotation.paymentStatus === 'overdue' && pendingAmount > 0) {
//       stats.totalOverdueAmount += pendingAmount;
//     } else if (quotation.validUntil && pendingAmount > 0) {
//       // Also check if validUntil date has passed
//       const validUntil = new Date(quotation.validUntil);
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       validUntil.setHours(0, 0, 0, 0);
//       if (validUntil < today) {
//         stats.totalOverdueAmount += pendingAmount;
//       }
//     }
//   });

//   // Round to 2 decimal places
//   Object.keys(stats).forEach(key => {
//     if (key.includes('Amount')) {
//       stats[key] = Math.round(stats[key] * 100) / 100;
//     }
//   });

//   return stats;
// };

// ==================== UPDATED SERVICE FUNCTIONS ====================

// Get Dashboard Analytics
export const getDashboardAnalytics = async (userId, role, companyId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      userId,
      role,
      ...(companyId && { companyId }),
      ...(filters.date && { date: filters.date }),
      ...(filters.month && { month: filters.month }),
      ...(filters.year && { year: filters.year })
    });

    const response = await fetch(`${url}/api/dashboard/analytics?${params}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching dashboard analytics:', error);
    throw error;
  }
};

// Get Today's Overview
export const getTodaysOverview = async (userId, role, companyId, date = null) => {
  try {
    const params = new URLSearchParams({
      userId,
      role,
      ...(companyId && { companyId }),
      ...(date && { date })
    });

    const response = await fetch(`${url}/api/dashboard/today-overview?${params}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching today overview:', error);
    throw error;
  }
};

// Get Tomorrow's Reminders
export const getTomorrowsReminders = async (userId, role, companyId, date = null) => {
  try {
    const params = new URLSearchParams({
      userId,
      role,
      ...(companyId && { companyId }),
      ...(date && { date })
    });

    const response = await fetch(`${url}/api/dashboard/tomorrow-reminders?${params}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching tomorrow reminders:', error);
    throw error;
  }
};

// In dashboardService.js - ADD THIS FUNCTION
export const getQuotationStatisticsForDashboard = async (userId, companyId) => {
  try {
    const response = await fetch(
      `${url}/api/leads/fetch-quotations?userId=${userId}&role=admin&companyId=${companyId}&includePayments=true`
    );

    const data = await response.json();

    if (data.success && data.data) {
      // Calculate stats using EXACT SAME LOGIC as QuotationsScreen
      const stats = calculateQuotationStats(data.data);
      return {
        success: true,
        data: stats
      };
    } else {
      return {
        success: false,
        message: data.message || 'No quotation data'
      };
    }
  } catch (error) {
    console.error('Error fetching quotation stats:', error);
    return {
      success: false,
      message: 'Failed to fetch quotation statistics'
    };
  }
};

// EXACT COPY of calculateQuotationStats from QuotationsScreen.jsx
const calculateQuotationStats = (quotations) => {
  console.log("📈 Starting stats calculation for", quotations.length, "quotations");

  const stats = {
    shared: 0,
    approved: 0,
    rejected: 0,
    revised: 0,
    total: quotations.length,
    totalQuotationAmount: 0,
    totalApprovedAmount: 0,
    totalReceivedAmount: 0,
    totalPendingAmount: 0,
    totalOverdueAmount: 0,
    totalTokenAmount: 0,
    totalPartiallyPaidAmount: 0,
    totalFullyPaidAmount: 0
  };

  quotations.forEach((quotation, index) => {
    console.log(`\n📊 Processing quotation ${index + 1}/${quotations.length}:`, {
      quotationNumber: quotation.quotationNumber,
      status: quotation.status,
      originalStatus: quotation.originalStatus,
      leadStatus: quotation.leadStatus,
      paymentStatus: quotation.paymentStatus,
      finalAmount: quotation.finalAmount,
      originalApprovedAmount: quotation.originalApprovedAmount,
      overdueAmount: quotation.overdueAmount,
      isRevised: quotation.isRevised,
    });

    // 🚨 CRITICAL FIX: Determine the REAL status for counting
    let effectiveStatus = quotation.status;
    let isEffectivelyApproved = false;

    // If quotation has originalStatus, use it (for overdue quotations)
    if (quotation.originalStatus && quotation.paymentStatus === 'overdue') {
      effectiveStatus = quotation.originalStatus;
      console.log(`🔄 Using originalStatus for overdue quotation: ${effectiveStatus}`);
    }

    // 🚨 UPDATED: Check if quotation should be counted as approved
    isEffectivelyApproved =
      // Direct status checks
      effectiveStatus === "approved" ||
      effectiveStatus === "quotation_approved" ||
      // Lead status checks
      quotation.leadStatus === "quotation_approved" ||
      quotation.leadStatus === "approved" ||
      quotation.quotationStatus === "quotation_approved" ||
      // Check if it has originalApprovedAmount (was approved before)
      (quotation.originalApprovedAmount > 0) ||
      // Special case: overdue but has originalApprovedAmount
      (quotation.paymentStatus === 'overdue' && quotation.originalApprovedAmount > 0);

    console.log("🎯 Effective status determination:", {
      effectiveStatus,
      isEffectivelyApproved,
      originalApprovedAmount: quotation.originalApprovedAmount,
      originalStatus: quotation.originalStatus,
      paymentStatus: quotation.paymentStatus,
    });

    // Count by effective status
    if (effectiveStatus === "quotation_shared" || effectiveStatus === "sent") {
      stats.shared++;
      console.log("➕ Added to shared count");
    }

    if (isEffectivelyApproved) {
      stats.approved++;
      console.log("✅ Added to approved count");
    }

    if (effectiveStatus === "quotation_rejected" || effectiveStatus === "rejected") {
      stats.rejected++;
      console.log("➕ Added to rejected count");
    }

    if (quotation.isRevised) {
      stats.revised++;
      console.log("➕ Added to revised count");
    }

    // 🚨 FIXED: Calculate amounts properly
    const quotationAmount = Number(quotation.finalAmount) || Number(quotation.totalAmount) || 0;

    // 🚨 CRITICAL: Use originalApprovedAmount if available, otherwise use quotation amount
    let approvedAmountForCalculation = quotationAmount;

    // 🚨 USE APPROVED AMOUNT IF AVAILABLE
    if (quotation.approvedAmount && quotation.approvedAmount > 0) {
      approvedAmountForCalculation = Number(quotation.approvedAmount);
      console.log(`💰 Using lead-level approvedAmount: ${approvedAmountForCalculation}`);
    } else if (quotation.originalApprovedAmount && quotation.originalApprovedAmount > 0) {
      approvedAmountForCalculation = quotation.originalApprovedAmount;
      console.log(`💰 Using originalApprovedAmount: ${approvedAmountForCalculation}`);
    } else if (isEffectivelyApproved && quotationAmount > 0) {
      approvedAmountForCalculation = quotationAmount;
      console.log(`💰 Using quotation amount as approved: ${approvedAmountForCalculation}`);
    }

    // Calculate received amount from actual payments (excluding overdue records)
    let receivedAmount = 0;
    let tokenAmount = 0;
    let partiallyPaidAmount = 0;
    let fullyPaidAmount = 0;

    if (quotation.payments && Array.isArray(quotation.payments)) {
      quotation.payments.forEach(payment => {
        const paymentAmount = Number(payment.amount) || 0;

        if (!payment.isOverdueRecord) {
          receivedAmount += paymentAmount;

          if (payment.paymentType === 'token') {
            tokenAmount += paymentAmount;
          } else if (payment.paymentType === 'partially_paid') {
            partiallyPaidAmount += paymentAmount;
          } else if (payment.paymentType === 'fully_paid') {
            fullyPaidAmount += paymentAmount;
          }
        }
      });
    } else {
      // Fallback to paidAmount field if payments array doesn't exist
      receivedAmount = Number(quotation.paidAmount) || 0;
    }

    console.log("💰 Payment calculations:", {
      quotationAmount,
      approvedAmountForCalculation,
      receivedAmount,
      tokenAmount,
      partiallyPaidAmount,
      fullyPaidAmount,
    });

    // 🚨 FIXED: Approved amount calculation
    // Include in totalApprovedAmount if effectively approved
    if (isEffectivelyApproved) {
      stats.totalApprovedAmount += approvedAmountForCalculation;
      console.log(`💰 Added ${approvedAmountForCalculation} to totalApprovedAmount`);
    }

    stats.totalQuotationAmount += quotationAmount;
    stats.totalReceivedAmount += receivedAmount;
    stats.totalTokenAmount += tokenAmount;
    stats.totalPartiallyPaidAmount += partiallyPaidAmount;
    stats.totalFullyPaidAmount += fullyPaidAmount;

    // 🚨 FIXED: Overdue/Pending amount calculation
    // NEW FLOW: Any approved but unpaid amount is NOT overdue yet.
    // Standardized Rule: Approved + Some Payment + Remaining = Overdue
    if (isEffectivelyApproved && receivedAmount > 0) {
      const remainingAmount = Math.max(0, approvedAmountForCalculation - receivedAmount);
      if (remainingAmount > 0) {
        stats.totalOverdueAmount += remainingAmount;
        stats.totalPendingAmount += remainingAmount;
        console.log(`📊 Added outstanding amount to Overdue: ${remainingAmount} (${approvedAmountForCalculation} - ${receivedAmount})`);
      }
    } else if (quotation.paymentStatus === 'overdue' && receivedAmount > 0) {
      // Fallback for explicitly marked overdue 
      const remainingAmount = Math.max(0, approvedAmountForCalculation - receivedAmount);
      if (remainingAmount > 0) {
        stats.totalOverdueAmount += remainingAmount;
      }
    }
  });

  // Round to 2 decimal places
  Object.keys(stats).forEach(key => {
    if (key.includes('Amount')) {
      stats[key] = Math.round(stats[key] * 100) / 100;
    }
  });

  console.log("\n📈 FINAL STATS CALCULATED:", {
    total: stats.total,
    shared: stats.shared,
    approved: stats.approved,
    rejected: stats.rejected,
    revised: stats.revised,
    totalQuotationAmount: stats.totalQuotationAmount,
    totalApprovedAmount: stats.totalApprovedAmount,
    totalReceivedAmount: stats.totalReceivedAmount,
    totalPendingAmount: stats.totalPendingAmount,
    totalOverdueAmount: stats.totalOverdueAmount,
  });

  return stats;
};

// Get Team Performance Details
export const getTeamPerformanceDetails = async (userId, companyId, teamMemberId = null) => {
  try {
    const params = new URLSearchParams({
      userId,
      companyId,
      ...(teamMemberId && { teamMemberId })
    });

    const response = await fetch(`${url}/api/dashboard/team-performance-details?${params}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching team performance details:', error);
    throw error;
  }
};

// Get Company Performance (for Super Admin)
export const getCompanyPerformance = async (companyId = null) => {
  try {
    const params = new URLSearchParams();
    if (companyId && companyId !== 'all') {
      params.append('companyId', companyId);
    }

    const response = await fetch(`${url}/api/dashboard/company-performance?${params}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching company performance:', error);
    throw error;
  }
};

// ==================== UPDATED QUOTATION FUNCTIONS ====================

// Get Team Performance With Quotations - UPDATED WITH PROPER STRUCTURE
export const getTeamPerformanceWithQuotations = async (userId, companyId, filters = {}) => {
  try {
    console.log('🔄 Fetching team performance with quotations with filters:', filters);

    const params = new URLSearchParams({
      userId,
      role: 'admin',
      companyId,
      includePayments: 'true',
      ...(filters.date && { date: filters.date }),
      ...(filters.month && { month: filters.month }),
      ...(filters.year && { year: filters.year })
    });

    const response = await fetch(`${url}/api/leads/fetch-quotations?${params}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('📊 Raw API response:', data);

    if (data.data && Array.isArray(data.data)) {
      console.log('✅ Received', data.data.length, 'quotations from API');

      // Apply the SAME calculation logic as QuotationsScreen
      const overallStats = calculateQuotationStats(data.data);

      console.log('📈 Calculated team quotation stats:', overallStats);

      return {
        success: true,
        data: overallStats // Return the stats directly, not nested
      };
    } else {
      console.warn('⚠️ No data returned for team performance with quotations');
      return {
        success: false,
        data: null,
        message: 'No quotation data available'
      };
    }
  } catch (error) {
    console.error('❌ Error fetching team performance with quotations:', error);
    return {
      success: false,
      data: null,
      message: error.message
    };
  }
};


// Get Team Member Personal Quotation Analytics - UPDATED
export const getTeamMemberPersonalQuotationAnalytics = async (userId, companyId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      userId,
      role: 'teamMember',
      includePayments: 'true',
      ...(companyId && { companyId }),
      ...(filters.date && { date: filters.date }),
      ...(filters.month && { month: filters.month }),
      ...(filters.year && { year: filters.year })
    });

    const response = await fetch(`${url}/api/leads/fetch-quotations?${params}`);
    const data = await response.json();

    if (data.data && Array.isArray(data.data)) {
      console.log('📊 Raw quotations data for team member:', data.data.length, 'quotations');

      // Apply the SAME calculation logic as QuotationsScreen
      const stats = calculateQuotationStats(data.data);

      console.log('📈 Calculated team member quotation stats:', stats);

      return {
        success: true,
        data: stats
      };
    } else {
      console.warn('⚠️ No data returned for team member personal quotations');
      return {
        success: false,
        data: null,
        message: 'No quotation data available'
      };
    }
  } catch (error) {
    console.error('❌ Error fetching team member personal quotation analytics:', error);
    return {
      success: false,
      data: null,
      message: error.message
    };
  }
};

// Get Team Member Quotation Analytics (for specific team member) - UPDATED
export const getTeamMemberQuotationAnalytics = async (userId, companyId, teamMemberId = null) => {
  try {
    let fetchUrl = `${url}/api/leads/fetch-quotations?userId=${userId}&role=admin&companyId=${companyId}&includePayments=true`;

    if (teamMemberId) {
      fetchUrl += `&teamMemberId=${teamMemberId}`;
    }

    const response = await fetch(fetchUrl);
    const data = await response.json();

    if (data.data) {
      console.log(`📊 Raw quotations data for team member ${teamMemberId}:`, data.data.length, 'quotations');

      // Filter quotations for the specific team member if teamMemberId is provided
      let filteredData = data.data;
      if (teamMemberId) {
        filteredData = data.data.filter(quotation =>
          quotation.assignedTo === teamMemberId || quotation.userId === teamMemberId
        );
      }

      // Apply the SAME calculation logic as QuotationsScreen
      const stats = calculateQuotationStats(filteredData);

      console.log(`📈 Calculated quotation stats for team member ${teamMemberId}:`, stats);

      return {
        success: true,
        data: stats
      };
    } else {
      return {
        success: false,
        data: null,
        message: 'No quotation data available'
      };
    }
  } catch (error) {
    console.error('❌ Error fetching team member quotation analytics:', error);
    return {
      success: false,
      data: null,
      message: error.message
    };
  }
};

// ==================== ALTERNATIVE APPROACH - IF YOU WANT TO KEEP EXISTING ENDPOINTS ====================

// Alternative: If you want to keep using dashboard-specific endpoints but ensure they include payment data
export const getTeamPerformanceWithQuotationsAlt = async (userId, companyId) => {
  try {
    const response = await fetch(`${url}/api/dashboard/team-performance-with-quotations?userId=${userId}&companyId=${companyId}&includePayments=true`);
    const data = await response.json();

    if (data.success && data.data) {
      console.log('📊 Team performance with quotations data (alt):', data.data);

      // If the backend doesn't calculate amounts properly, calculate them here
      if (data.data.quotations) {
        const stats = calculateQuotationStats(data.data.quotations);
        return {
          success: true,
          data: {
            ...data.data,
            ...stats
          }
        };
      }

      return data;
    } else {
      throw new Error(data.message || 'Failed to fetch team performance with quotations');
    }
  } catch (error) {
    console.error('❌ Error fetching team performance with quotations (alt):', error);
    throw error;
  }
};

// Alternative for team member personal analytics
export const getTeamMemberPersonalQuotationAnalyticsAlt = async (userId, companyId) => {
  try {
    let fetchUrl = `${url}/api/dashboard/team-member-personal-quotations?userId=${userId}&includePayments=true`;

    if (companyId) {
      fetchUrl += `&companyId=${companyId}`;
    }

    const response = await fetch(fetchUrl);
    const data = await response.json();

    if (data.success && data.data) {
      console.log('📊 Team member personal quotation analytics (alt):', data.data);

      // If the backend doesn't calculate amounts properly, calculate them here
      if (data.data.quotations) {
        const stats = calculateQuotationStats(data.data.quotations);
        return {
          success: true,
          data: {
            ...data.data,
            ...stats
          }
        };
      }

      return data;
    } else {
      throw new Error(data.message || 'Failed to fetch team member personal quotation analytics');
    }
  } catch (error) {
    console.error('❌ Error fetching team member personal quotation analytics (alt):', error);
    throw error;
  }
};

// In services/dashboardService.js - ADD NEW FUNCTION

// Get Team Member Detailed Analytics
export const getTeamMemberDetailedAnalytics = async (userId, companyId, teamMemberId, filters = {}) => {
  try {
    console.log('🔄 Fetching team member detailed analytics with filters:', filters);

    const params = new URLSearchParams({
      userId,
      companyId,
      teamMemberId,
      ...(filters.date && { date: filters.date }),
      ...(filters.month && { month: filters.month }),
      ...(filters.year && { year: filters.year })
    });

    const response = await fetch(`${url}/api/dashboard/team-member-detailed-analytics?${params}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
      console.log('✅ Team member detailed analytics fetched:', data.data);
      return data;
    } else {
      throw new Error(data.message || 'Failed to fetch team member detailed analytics');
    }
  } catch (error) {
    console.error('❌ Error fetching team member detailed analytics:', error);
    return {
      success: false,
      data: null,
      message: error.message
    };
  }
};